import React, { Component } from "react";
import PropTypes from "prop-types";
import { RightOutlined } from "@ant-design/icons";
import { Button } from "antd";
import "../assets/stylus/no_access.styl";
import tipLogo from "../assets/img/img_no_access.svg";

class NoMenu extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      time: 10,
    };
  }

  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  componentDidMount() {
    this.interval = setInterval(() => {
      this.countdown();
    }, 1000);
  }

  goBack() {
    this.context.router.history.push("/home");
  }

  countdown() {
    let newTime = this.state.time;
    newTime -= 1;
    if (newTime < 0) {
      clearInterval(this.interval);
      this.goBack();
    } else {
      this.setState({
        time: newTime,
      });
    }
  }

  render() {
    const InfoDom = (
      <div className='infoWrap'>
        <div className='access-box'>
          <div className='access-logo'>
            <img src={tipLogo} alt='' />
          </div>
          <div className='access-context'>你暂时没有菜单权限或者登录已超时，请联系管理员添加权限</div>
          <div style={{ paddingTop: "10px" }}>
            即将跳转登录页 <span>{this.state.time}</span>秒{" "}
            <Button
              type='primary'
              style={{ marginLeft: "10px" }}
              size='small'
              onClick={() => {
                this.goBack();
                clearInterval(this.interval);
              }}>
              立即跳转
              <RightOutlined />
            </Button>
          </div>
        </div>
      </div>
    );
    return InfoDom;
  }
}

export default NoMenu;



// WEBPACK FOOTER //
// ./src/AntD/pages/no_menu.js